import React, { JSX } from 'react';
import { StyledCard } from './style';
import { SpaceProps } from 'styled-system';
import Title from '../Title';

type CardType = SpaceProps & {
  children: JSX.Element | string;
  title?: JSX.Element | string;
};
const Card: React.FC<CardType> = ({ children, title, ...rest }) => {
  return (
    <StyledCard {...rest}>
      {title && <Title title={title} />}
      {children}
    </StyledCard>
  );
};

export default Card;
